import AxiosInstance from './config/Http'
import Config from './config/Constants'

export default {
    get: (id: string) =>
    AxiosInstance.get<any>(`${Config.profile.companies}/${id}`)
}